module.exports = __webpack_public_path__ + "static/img/titleBg.8d333e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/titleBg.png
// module id = kLyF
// module chunks = 1